module.exports = __webpack_public_path__ + "static/media/add-client-badge.f102c731.png";